module.exports = __webpack_public_path__ + "img/icon-4.cad4f196.svg";